<template>

<div class="icon">
	
    <i :class="{[clsIcon]: true}" class="icon-icon" />

</div>

</template>

<script>

export default {
	
    props: ['n'],

    data: function() {

        return {
            shortcuts: {
                loading: 'fa-regular fa-spinner fa-spin',
                search: 'fa-regular fa-magnifying-glass',
                remove: 'fa-regular fa-times',
                trend_up: 'fa-regular fa-arrow-up-right',
                trend_down: 'fa-regular fa-arrow-down-right',
                report_data: 'fa-thin fa-gear',
                report_cards: 'fa-thin fa-chart-pie',
                report_map: 'fa-thin fa-map',
                report_insights: 'fa-thin fa-stars',
                map_pin: 'fa-regular fa-location-dot'
            }
        }
        
    },

    computed: {

        clsIcon: function() {

            return this.shortcuts[this.n]

        }

    }

}

</script>

<style scoped>

.icon {
    
}

</style>
